import { RawRuleOf } from '@casl/ability';

import { SubjectAbilitiesDto } from '../dtos/subject-abilities.dto';
import { AppAbility } from '../types/app-ability';

/**
 * Maps subject abilities used by the app to display permissions to rules used by CASL for authorization
 * @param subjectAbilities subject abilities to map
 * @returns rules
 */
export function mapSubjectAbilitiesToRules(
	subjectAbilities: SubjectAbilitiesDto[],
): RawRuleOf<AppAbility>[] {
	return subjectAbilities.flatMap((subjectAbility) =>
		subjectAbility.abilities.map((ability) => ({
			subject: subjectAbility.subject,
			action: ability.action,
			inverted: !ability.allow,
		})),
	);
}
